"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserCheck = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17.005 7a5 5 0 11-10 0 5 5 0 0110 0zm-2 0a3 3 0 10-6 0 3 3 0 006 0zm-13 13c0-4.243 2.336-6 5.76-5.997.023 0-.746.824-.746 2.062 0 0-3.014.054-3.014 3.935h5.778l2.044 2H4.005c-2.205 0-2-2-2-2zm18 0c0-1.249-.296-2.206-.888-2.872l1.512-1.498c.9.999 1.359 2.456 1.376 4.37 0 1.333-.667 2-2 2h-5.768l2.01-2h3.758zm.294-9.707a1 1 0 111.414 1.414l-8 8a1 1 0 01-1.414 0l-3.001-3.001a1 1 0 011.414-1.414l2.294 2.294 7.293-7.293z' }))); };
exports.default = SvgUserCheck;
//# sourceMappingURL=UserCheck.js.map